import { createFileRoute } from "@tanstack/react-router";
import { ArtifactEditorView } from "@client/components/doc-generation/artifact-editor-page";

export const Route = createFileRoute("/_app/doc-generation/$taskId/artifact")({
  component: Artifact,
});

function Artifact() {
  const { taskId } = Route.useParams();
  return <ArtifactEditorView taskId={taskId} />;
}
